import React, { CSSProperties, FC } from 'react';
import nfcIcon from '../../../../assets/images/nfc-bubble.png';
import { COLORS } from '../../../utils/Colors';

export const TutorialSlideOne: FC = () => {
  const styles = {
    root: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    } as CSSProperties,
    image: {
      width: '35%',
    } as CSSProperties,
    title: {
      width: '100%',
      textAlign: 'center',
      fontSize: 18,
      fontWeight: 700,
      marginTop: 10,
    } as CSSProperties,
    body: {
      width: '100%',
      textAlign: 'center',
      marginBlock: 10,
      color: COLORS.LIGHT_GRAY,
    } as CSSProperties,
  };

  return (
    <div style={styles.root}>
      <img src={nfcIcon} alt="NFC" style={styles.image} />
      <span style={styles.title}>Tap to login</span>
      <span style={styles.body}>Hold your phone over the contact logo on the Olyns Container Cube.</span>
    </div>
  );
};
